<script>
import { componentStore } from '@common/componentStore/componentStore';
import mockConfig from '../mockConfig';
import tabList from '../../../common/tabList/tabList.vue';

const profileTabsConfig = {
    cId: 'profileTabs',
    cType: 'profile-tabs',
    cTitle: 'Profile Tabs',
    showInCmpList: false,
    cTemplate: `<div class="profile-tabs flex">
                    <div
                        v-for="tab in tabs"
                        :key="tab.id"
                        class="profile-tab"
                        :class="{ active: activeTab === tab.id }"
                        @click="selectTab(tab.id)"
                    >
                    <Icon :class="{ 'tab-icon': tab.icon }"
                        :name="tab.icon"
                        :size="'lg'"
                        :color="'var(--text-color-body)'">
                    </Icon>
                    <span>{{ tab.label }}</span>
                    </div>
                </div>`
};

const profileTabsCmp = {
    name: 'profile-tabs',
    components: {
        'tab-list': tabList,
    },
    props: {
        tabs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            mockData: {},
            activeTab: null,
            visitedTabs: {},
            tabPanelReady: {},
        };
    },
    methods: {
        onLoad() {
            // TODO: Replace mockData with this.config when configStore is hooked up
            this.mockData = mockConfig;
            this.tabs = mockConfig.tabs;
            if (this.tabs.length) {
                this.activeTab = this.tabs[0].id;
                this.selectTab(this.tab);
            }
        },
        dashboardLayoutCreated(tabId) {
            this.tabPanelReady[tabId] = true;
        },
        selectTab(selectedTab) {
            const tab = this.tabs.find((t) => t.id === selectedTab);
            if (tab) {
                this.activeTab = tab.id;
                this.visitedTabs[tab.id] = true;
                this.$emit('change-tab', tab.id);
            }
        }
    }
};

componentStore.initComponent(profileTabsCmp, profileTabsConfig);
export default profileTabsCmp;
</script>

<style scoped>
    .profile-tabs {
        border-bottom: 1px solid var(--border-color-default);
        border-top: 1px solid var(--border-color-default);
        padding-left: var(--space-4);
    }
    .profile-tab {
        color: var(--text-color-body);
        cursor: pointer;
        font-size: var(--text-size-headline);
        font-weight: var(--text-weight-medium);
        padding: var(--space-5);
        margin: var(--space-2) var(--space-4) var(--space-4);
        letter-spacing: 0.2px;
        position: relative;
        display: inline-block;
        transition: color 180ms ease;
    }
    .profile-tab::after {
        color: var(--border-color-default-primary);
        content: "";
        position: absolute;
        left: 0;
        bottom: -1px;
        width: 100%;
        height: 3px;
        background-color: var(--border-color-default-primary);
        border-radius: var(--radius-3xs);

        transform: scaleX(0);
        transform-origin: left;
        opacity: 0;
        transition:
                transform 240ms cubic-bezier(.2,.8,.2,1),
                opacity 180ms ease;
    }
    .profile-tab.active {
        color: var(--primary-700);
    }
    .profile-tab.active .tab-icon {
        color: var(--primary-700) !important;
    }
    .profile-tab.active::after {
        color: var(--grayscale-200);
        font-weight: var(--text-weight-semibold);
        transform: scaleX(1);
        opacity: 1;
    }
    .profile-tab .tab-icon {
        padding-right: var(--space-4);
    }
</style>
